import { render, staticRenderFns } from "./IconDocumentSearch.vue?vue&type=template&id=1ceb397c"
import script from "./IconDocumentSearch.vue?vue&type=script&lang=js"
export * from "./IconDocumentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports